import { FC } from "react";
import { SxProps, TextField, Tooltip } from "@mui/material";
import { TextFieldProps } from "@mui/material/TextField/TextField";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";

type IAppTextField = TextFieldProps & {
  sxStyle?: SxProps | undefined;
  tooltip?: string | undefined;
  error1?: string | undefined;
};

export const AppTextField: FC<IAppTextField> = ({
  sxStyle,
  tooltip,
  error1,
  ...props
}: IAppTextField) => {
  const { active_incluir } = useConfigPageContext();

  return (
    <Tooltip enterDelay={2000} enterNextDelay={2000} title={tooltip || ""}>
      <TextField
        {...props}
        focused
        error={!!error1}
        helperText={error1}
        size={props.size ?? "small"}
        sx={{
          opacity: !active_incluir ? ".5" : "",
          pointerEvents: !active_incluir ? "none" : "auto",
          margin: "4px 6px",
          ...sxStyle,
        }}
        type={props.type ?? "search"}
        variant={props.variant ?? "standard"}
      />
    </Tooltip>
  );
};
